import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";

import { updateUserInfo } from "../../auth/authSlice";

const LogoUploadBox = () => {
  const dispatch = useDispatch();

  const [selectedFile, setSelectedFile] = useState(null);
  const [dragging, setDragging] = useState(false);
  const fileInputRef = useRef(null);

  // 드래그 오버 시 기본 이벤트 제거
  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => setDragging(false);

  // 파일 드롭 시 파일 선택 처리
  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setSelectedFile(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };

  // 파일 입력 변화 처리
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedFile(e.target.files[0]);
    }
  };

  // 업로드 버튼 클릭 시 API 호출
  const handleUpload = async () => {
    if (!selectedFile) {
      alert("이미지를 선택해주세요.");
      fileInputRef.current.click();
      return;
    }

    const formData = new FormData();
    formData.append("logo_img", selectedFile);
    try {
      await dispatch(updateUserInfo(formData)).unwrap();
      alert("로고 이미지가 변경되었습니다.");
    } catch (err) {
      alert("로고 업로드에 실패했습니다. 잠시 후 다시 시도해주세요.");
      console.error("로고 업로드 실패:", err);
    }
  };

  return (
    <div style={{ padding: "16px" }}>
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current.click()}
        style={{
          position: "relative",
          border: dragging ? "2px dashed #00D9C0" : "2px dashed #B9C1C9",
          borderRadius: "18px",
          backgroundColor: dragging ? "#F2FAF8" : "#FAFCFB",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          cursor: "pointer",
          transition: "all .15s",
        }}
      >
        {selectedFile ? (
          <img
            src={URL.createObjectURL(selectedFile)}
            alt="미리보기"
            style={{ width: "100%", maxHeight: "150px", objectFit: "contain", padding: "20px" }}
          />
        ) : (
          <div
            style={{
              padding: "44px 40px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "14px",
            }}
          >
            {/* 말풍선 로고 모양 업로드 아이콘 */}
            <svg viewBox="0 0 64 48" xmlns="http://www.w3.org/2000/svg" style={{ height: "52px", width: "auto", opacity: 0.9 }}>
              <path d="M22 4a17 17 0 1 0 0 34c1.2 0 2.4-.13 3.5-.37L20 46l12-9.5A17 17 0 0 0 22 4z" fill="#B9C1C9" />
              <path d="M42 8a15.5 15.5 0 1 1 0 31c-1 0-2-.1-3-.3L44 46l-9.5-8.3A15.5 15.5 0 0 1 42 8z" fill="#00D9C0" />
            </svg>
            <div style={{ fontSize: "0.95rem", fontWeight: 700, color: "#3A434E" }}>
              학원 로고를 이곳에 드래그하세요
            </div>
            <div style={{ fontSize: "0.8rem", color: "#7A8490", fontWeight: 600 }}>
              또는 클릭해서 파일 선택 · 권장: 가로형 로고, PNG
            </div>
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleUpload();
          }}
          style={{
            position: "absolute",
            bottom: "14px",
            right: "14px",
            padding: "8px 20px",
            backgroundColor: "#0E141B",
            color: "#fff",
            fontSize: "0.84rem",
            fontWeight: 700,
            fontFamily: "inherit",
            border: "none",
            borderRadius: "999px",
            cursor: "pointer",
            transition: "background-color .12s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#00A396")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#0E141B")}
        >
          변경하기
        </button>
      </div>
    </div>
  );
};

export default LogoUploadBox;
